import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { Category } from "./category";
import { CategoriesGridCon } from "./style";

type CategoriesGridProps = {
  categories: { name: string; logo: string }[];
};
export const CategoriesGrid = ({ categories }: CategoriesGridProps) => {
  return (
    <CategoriesGridCon>
      <div className="heading">
        <p className="title">Popular Categories</p>

        <Link to="/supermarket">See All</Link>
      </div>
      <div className="content">
        {categories.length > 0 &&
          [...categories].reverse().map(({ name, logo }, id) => (
            <Category key={id} img={logo} name={name} />
          ))}
      </div>
    </CategoriesGridCon>
  );
};
